<script>
import Layout from '@layout/main'
import DialogContact from '@components/Dialog/Contact'
import DialogCancel from '@components/Dialog/CancelOrder'
import formatDate from '@utils/format-date'
import MemberEventIntroduction from '@components/List/MemberEventIntroduction'
import MemberTabList from './components/MemberTabList'
import CancelOrderList from './components/CancelOrderList.vue'
import { orderRegStatusItem } from '@utils/zerone-order'

export default {
  page() {
    return {
      title: `${this.orderItem.title} | 訂單資訊`,
    }
  },
  filters: {
    formatDate,
  },
  components: {
    Layout,
    DialogContact,
    DialogCancel,
    MemberEventIntroduction,
    MemberTabList,
    CancelOrderList,
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      activeCollapse: 0,
      step: 1,
      isDialogContactVisible: false,
      isDialogCancelVisible: false,
      brandsList: [],
    }
  },
  computed: {
    linkBrandEventItem() {
      return {
        name: 'brand-event-item',
        params: {
          brandAlias: this.orderItem.brands[0]?.alias,
          eventAlias: this.orderItem.alias,
          eventSeriesNum: this.orderItem.seriesNum,
        },
      }
    },
  },
  methods: {
    openDialogContact(item) {
      this.isDialogContactVisible = true
      this.brandsList = item
    },
    handleChange(val) {
      if (val.length === 1) {
        return false
      }
    },
    statusItem(regStatus) {
      return orderRegStatusItem(regStatus)
    },
    goBack() {
      const routeMap = () => {
        return {
          'member-event-item': 'member-event-list',
          'member-activity-item': 'member-activity-list',
        }
      }

      return {
        name: routeMap()[this.$route.name],
      }
    },
    goToBrand(item) {
      this.$router.push({
        name: 'brand-item',
        params: {
          brandAlias: item.alias,
        },
      })
    },
    setStep() {
      const vm = this
      vm.step = 2
      this.$scrollToElement({
        $el: this.$refs['sectionList'],
        offset: 270,
      })
    },
    backStep() {
      const vm = this
      vm.step = 1
      this.$scrollToElement({
        $el: this.$refs['sectionList'],
        offset: 270,
      })
    },
    goToGoogleCalendar() {
      const text = '零壹活動'
      const dates = ``
      const details = '測試文字測試文字測試文字'
      const location = '林酒店6F仙侶廳(台中市西屯區朝富路99號)'
      const query = `action=TEMPLATE&text=${text}&dates=${dates}&details=${details}&location=${location}&trp=false`

      window.open(`http://www.google.com/calendar/event?${query}`)

      // dates   時間格式為 YYYYMMDDTHHMMSS
      // details 使用 %0A 作為跳行
    },
  },
}
</script>
<template>
  <Layout type="brand">
    <BaseBanner :title="orderItem.title || '零壹課程'" :image="require('@assets/images/member/banner.png')" type="event" custom-class="isStyleWhite isArticle isDefaultBgEventItem">
      <el-tag v-if="orderItem.type === 'online'" class="isStylePrimary isAngle d-md-none"> LIVE </el-tag>
    </BaseBanner>
    <section :class="$style.MemberEventIntroduction" class="section">
      <div class="container">
        <div class="d-flex justify-content-md-between mb-lg-5 mb-3">
          <div v-if="!!orderItem.brands.length" class="d-lg-none d-block">
            <template v-if="orderItem.brands.length === 1">
              <div class="MemberEventIntroduction__img" @click="goToBrand(orderItem.brands[0])">
                <img v-if="orderItem.brands[0].logo" class="img" :src="orderItem.brands[0].logo" :alt="orderItem.brands[0].title" />
                <div v-else>{{ orderItem.brands[0].title }}</div>
              </div>
            </template>
            <template v-else>
              <el-popover placement="bottom" trigger="click" width="335" popper-class="isStyleBase isStyleContact">
                <div class="row align-content-center h-100" :class="{ 'justify-content-center': orderItem.brands.length === 1 }">
                  <div
                    v-for="(brand, $index) in orderItem.brands"
                    :key="$index"
                    class="col-6 mb-2 text-center MemberEventIntroduction__img align-self-center"
                    style="cursor: pointer"
                    @click="goToBrand(brand)"
                  >
                    <img v-if="brand.logo" class="img" :src="brand.logo" :alt="brand.title" />
                    <div v-else>{{ brand.title }}</div>
                  </div>
                </div>
                <!-- <el-button slot="reference" class="isStyleContact">業務聯絡 <i class="fas fa-caret-down"></i></el-button> -->
                <div slot="reference" class="MemberEventIntroduction__brandsText"> 多品牌協辦 <i class="fal fa-chevron-down"></i> </div>
              </el-popover>
            </template>
          </div>
          <!-- <div>#訂單編號：#ZERONE2105230001A5TTP</div> -->
          <div class="ml-auto align-self-center text-sm md:text-base"
            >報名狀態：
            <el-tag :class="statusItem(orderItem.regStatus).class">
              {{ statusItem(orderItem.regStatus).title }}
            </el-tag>
          </div>
        </div>
        <MemberEventIntroduction :item="orderItem" />
        <div ref="sectionList"></div>

        <template v-if="step === 1">
          <MemberTabList :order-item="orderItem" />
        </template>
        <template v-else-if="step === 2">
          <CancelOrderList :order-item="orderItem" :detail="'detail'" @back="backStep" />
        </template>
        <BaseButton
          v-if="true && orderItem.regStatus !== 'CANCELED' && orderItem.registrationType === 'impartial'"
          class="isStylePrimary isOutline2 isFull isRadius mt-4"
          @click="isDialogCancelVisible = true"
        >
          取消場次報名
        </BaseButton>
        <template v-if="step === 1">
          <BaseButton v-if="true && orderItem.regStatus !== 'CANCELED' && orderItem.registrationType === 'partial'" class="isStylePrimary isOutline2 isFull isRadius mt-4" @click="setStep">
            取消場次報名
          </BaseButton>
          <BaseButton v-if="true" class="isStylePrimary isOutline2 isFull isRadius mt-4" :to="goBack()"> 回報名清單 </BaseButton>
          <div class="d-flex justify-content-between mt-4 MemberEventIntroduction__Btn flex-md-row flex-column">
            <!-- <BaseButton
            v-if="true"
            class="isStylePrimary isOutline2 isFull isRadius mb-md-0 mb-4"
            @click="goToGoogleCalendar"
          >
            加入行事曆
          </BaseButton> -->
            <BaseButton v-if="true" class="isStylePrimary isOutline2 isFull isRadius mb-md-0 mb-4" :to="linkBrandEventItem"> 查看活動資訊 </BaseButton>
            <BaseButton v-if="true" class="isStylePrimary isOutline2 isFull isRadius" @click="openDialogContact(orderItem.brands)"> 洽詢聯絡 </BaseButton>
          </div>
        </template>
        <template v-else-if="step === 2">
          <div class="row d-lg-flex d-none justify-content-center" style="margin-top: 70px">
            <div class="col"></div>
            <div class="col-7">
              <BaseButton v-if="true" class="isFull isStylePrimary isOutline2 isRadius" :to="goBack()"> 回報名清單 </BaseButton>
            </div>
            <div class="col"></div>
          </div>
          <div class="w-60 d-flex justify-content-center d-lg-none d-block" style="margin-top: 40px">
            <BaseButton v-if="true" class="isFull isStylePrimary isOutline2 isRadius" :to="goBack()"> 回報名清單 </BaseButton>
          </div>
        </template>
      </div>
    </section>
    <DialogContact :brands-list="brandsList" :visible.sync="isDialogContactVisible" />
    <DialogCancel :order-item="orderItem" :visible.sync="isDialogCancelVisible"></DialogCancel>
  </Layout>
</template>
<style lang="scss" module>
.MemberEventIntroduction {
  :global {
    .MemberEventIntroduction {
      &__img {
        .img {
          max-height: 65px;
          @include max-md {
            max-height: 42px;
          }
        }
      }
      &__Btn {
        .baseButton {
          &:not(:last-child) {
            margin-right: 1rem;
          }
        }
      }
      &__brandsText {
        width: 163px;
        max-width: 163px;
        height: 55px;
        line-height: 55px;
        color: $color-primary;
        text-align: center;
        border: 1px solid $color-primary;

        @include max-lg {
          width: 135px;
          height: 44px;
          font-size: 1rem;
          line-height: 44px;
        }
      }
    }
  }
}
</style>
